module.exports = __webpack_public_path__ + "static/media/click.94b9dcdf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/click.mp3
// module id = 36
// module chunks = 1